import { connect } from "react-redux";
import * as Redux from "redux";
import {
  flushReports,
  getReports,
  deleteReport,
  sendLatestReport
} from "../../actions";
import ViewReport from "./component";
import { Report } from "../../constants";

export interface ViewReportProps {
  reports: Report[];
  match?: any;
}

export interface ViewReportActions {
  getReports: (merchant_id: number) => void;
  deleteReport: (
    merchant_id: number,
    report_id: number,
    report_name: string
  ) => void;
  sendLatestReport: (merchant_id: number, report_id: number) => void;
  flushReports: () => void;
}

const mapStateToProps = (state: any): ViewReportProps => {
  return {
    reports: state.report.reports
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): ViewReportActions => {
  return {
    ...Redux.bindActionCreators(
      { flushReports, getReports, deleteReport, sendLatestReport },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewReport);



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReports/container.ts